module.exports = __webpack_public_path__ + "static/media/rooster.0ce169db.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/rooster.mp3
// module id = 60
// module chunks = 0